import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { maybeAddZeroBeforeNumber } from '@dealstack/shared/lib/format/number';
import { Text } from '@mantine/core';
import { memo } from 'react';
import styled, { css } from 'styled-components';
import type { SideTabItemV2Props } from './SideTabItemV2.types';

export enum SideTabItemV2State {
	default = 'default',
	active = 'active',
	completed = 'completed',
	disabled = 'disabled',
}

const SideTabItemV2 = ({ listNumber, title, state, onClick, className }: SideTabItemV2Props) => {
	return (
		<div className={className} onClick={onClick}>
			<CircleNumber>
				<Text fz="sm" fw={600}>
					{maybeAddZeroBeforeNumber(listNumber + 1)}
				</Text>
			</CircleNumber>
			<Text fz="sm" fw={600}>
				{title}
			</Text>
			{state === SideTabItemV2State.completed && <Icon variant="tick" size="lg" />}
		</div>
	);
};

const CircleNumber = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.5rem;
	height: 1.5rem;
	border-radius: 50%;
	border: 2px solid ${({ theme }) => theme.v2.color.black[500]};
	margin-right: 0.4rem;
`;

const Memoized = memo(SideTabItemV2);
const Styled = styled(Memoized)`
	display: flex;
	align-items: center;
	box-sizing: border-box;
	height: 3rem;
	padding: 1em;
	width: 100%;
	user-select: none;

	${Icon} {
		margin-left: auto;
	}

	${({ onClick, state }) =>
		onClick &&
		state !== SideTabItemV2State.disabled &&
		css`
			cursor: pointer;
		`}

	${({ state, theme }) => {
		switch (state) {
			case SideTabItemV2State.default:
				return css`
					background-color: ${theme.v2.color.neutral[200]};
					border: 1px solid ${theme.v2.color.neutral[300]};
				`;
			case SideTabItemV2State.active:
				return css`
					background-color: ${theme.v2.color.secondary[200]};
					border: 1px solid ${theme.v2.color.secondary[800]};
				`;
			case SideTabItemV2State.completed:
				return css`
					background-color: ${theme.v2.color.success[200]};
					border: 1px solid ${theme.v2.color.success[600]};
				`;
			case SideTabItemV2State.disabled:
				return css`
					background-color: ${theme.v2.color.neutral[200]};
					border: 1px solid ${theme.v2.color.neutral[300]};
					opacity: 32%;
				`;
		}
	}}
`;

export { Styled as SideTabItemV2 };
